export default __webpack_public_path__ + "static/media/sg.cef0bd55.svg";